// extracted by mini-css-extract-plugin
export var alertIcon = "_nh-0";